module.exports = {"140927100":"龙泉镇","140927101":"义井镇","140927102":"八角镇","140927200":"东湖乡","140927203":"贺职乡","140927204":"长畛乡","140927205":"烈堡乡","140927206":"大严备乡","140927400":"神池县城镇街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140927.json
// module id = 441
// module chunks = 0